import { promotionsData } from './data/promotions.data';

export const promotionsService = {
  applyCoupon: (couponCode: string) => promotionsData.applyCoupon(couponCode),
  removeCoupon: (couponCode: string) => promotionsData.removeCoupon(couponCode),
};
